<template>
  <div class="registration-confirmation">
    <h3>You're registered!</h3>

    <div>
      <b-button v-if="webinarInfo.inSession" variant="primary"
        @click="join"
        >
        Join Webinar in Progress
      </b-button>
      <!-- :style="{backgroundColor: brandingStyle.headerColor}" -->

      <div v-else>
        <p>At the time above, <a @click="join">join the webinar.</a></p>

        <p>Before joining, be sure to check system requirements to avoid any connection issues.</p>

        <p>A confirmation email with information on how to join the webinar has been sent to you.</p>

        <p>Questions or Comments? Contact:
          <a :href="`mailto:${this.webinarInfo.organizerEmail}`">{{ webinarInfo.organizerEmail }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const RegistrationConfirmation = {
  name: 'RegistrationConfirmation',

  props: {
    webinarKey: {
      type: String,
      required: true
    },
    registrantKey: {
      type: String,
      required: true
    }
  },

  computed: {
    webinarInfo() {
      return this.$store.state.g2wWebinar.webinarInfo;
    },

    registrant() {
      return this.$store.state.g2wRegistration.registrant;
    },

    displayStartTime() {
      return new Date(this.webinarInfo.times[0].startTime).toString();
    },

    organizerEmailHref() {
      return `mailto:${this.webinarInfo.organizerEmail}`;
    },

    registered() {
      return this.webinarInfo && this.registrant && this.registrant.status === 'APPROVED';
    },

    brandingStyle() {
      return this.$store.getters['g2wWebinar/brandingStyle'];
    }
  },

  created() {
    this.$store.dispatch('g2wWebinar/getRegistrant', {
      webinarKey: this.webinarKey,
      registrantKey: this.registrantKey
    })
      .then((registrant) => {
        this.$store.commit('g2wRegistration/setRegistrant', {registrant});
      })
      .catch((error) => {
        this.logger.log('cannot get webinar info or registrant', {error});
      });
  },

  methods: {
    join() {
      this.$router.push({
        name: 'attendance',
        params: {
          webinarKey: this.webinarKey,
          registrantKey: this.registrant.registrantKey
        }
      });
    }
  }
};

export default RegistrationConfirmation;

</script>

<style lang="sass">

  .registration-confirmation
    height: 100%
    text-align: center

    .col-result
      padding: 10px

    .registration-footer
      max-height: 200px

</style>
